import Vue from 'vue'
import App from './App.vue'
// 引入vant组件样式
import 'vant/lib/index.css';
import './rem.js'
import ElementUI from 'element-ui';


import { Button } from 'vant';
import less from 'less';
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
Vue.use(less);
Vue.use(Button)
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
